import { Link } from "react-router-dom";
import shape02 from "../../../Assets/img/shape02.svg";
import shape05 from "../../../Assets/img/shape05.svg";
import shape06 from "../../../Assets/img/shape06.svg";
import { useConfig } from "../../../context/ConfigContext";
import useSEOConfig from '../../../hooks/seo/useSEOConfig';
import { Navbar } from '../Components/Navbar';

const DATA_CONTACTO = {
    AR: {
        telefono: "54 9 11 2835 7048",
        horario_ventas: "08:30 a 20:30hs",
        hoario_atencion: "09:00 a 18:00hs"
    },
    UY: {
        telefono: "598 92 281 806",
        horario_ventas: "08:30 a 20:30hs",
        hoario_atencion: "09:00 a 17:00hs"
    },
    BR: {
        telefono: "",
        horario_ventas: "",
        hoario_atencion: ""
    }
}

export const FormularioArrepentimientoEnviado = () => {

    const { config } = useConfig()
    useSEOConfig(
        {
            title: "Formulario de Arrepentimiento - Segurarse",
            description: config.pais === "UY" ?
            "Formulario de revocación de aceptación del seguro contratado conforme a la Ley 17250. Complete el formulario para ejercer su derecho de arrepentimiento en Segurarse."
            :
            "Formulario de revocación de aceptación del seguro contratado según Resolución 424/2020 de la Secretaría de Comercio Interior. Complete el formulario para ejercer su derecho de arrepentimiento en Segurarse.",
            keywords: "formulario de arrepentimiento, revocación de seguro, Segurarse, Resolución 424/2020, derecho de arrepentimiento, ecommerce Segurarse",
            ogTitle: "Formulario de Arrepentimiento - Segurarse",
            ogDescription: "Complete el formulario de arrepentimiento para revocar su aceptación del seguro contratado en Segurarse conforme a la Resolución 424/2020 de la Secretaría de Comercio Interior.",
            twitterTitle: "Formulario de Arrepentimiento - Segurarse",
            twitterDescription: "Complete el formulario de arrepentimiento para revocar su aceptación del seguro contratado en Segurarse conforme a la Resolución 424/2020 de la Secretaría de Comercio Interior."
        }
    )
    return (
        <>
            <Navbar rubro='auto' />
            <main className='bg-white'>
                <div className="position-relative pt-45 pb-25 pt-lg-80 pb-lg-35">
                    <img className="d-none d-lg-block pos02" src={shape02} alt='' />
                    <div className="container">
                        <h1 className="ff-mukta fw-bold fs-30 fs-lg-36 lh-lg-1 text-black text-center text-lg-start mb-10">Formulario de arrepentimiento</h1>
                        <div className="col-md-10 col-lg-8 mx-auto mx-lg-0">
                            {
                                config.pais === "AR" &&
                                <>
                                    Conforme Resolución 424/2020, de la secretaria de Comercio Interior, las y los clientes pueden solicitar la revocación de la aceptación durante el plazo de DIEZ (10) días corridos contados a partir de la fecha de la celebración del seguro contratado únicamente mediante el canal ecommerce de la web (<a className='text-decoration-underline' href='https://segurarse.com.ar/' target='_blank'>www.segurarse.com.ar</a>).
                                </>
                            }
                            {
                                config.pais === "UY" &&
                                <>
                                    Conforme a la Ley 17.250, los clientes pueden solicitar la resolución o rescisión -de pleno derecho- del contrato celebrado vía online con SEGURARSE, dentro del plazo máximo de CINCO (5) días hábiles contados a partir de la fecha de la celebración del seguro contratado, mediante correo electrónico a la casilla <a className='text-decoration-underline' href='mailto:compliance@segurarse.com.uy'>compliance@segurarse.com.uy</a> o mediante el canal e-commerce de la web (<a className='text-decoration-underline' href='https://segurarse.com.uy/' target='_blank'>www.segurarse.com.uy</a>).
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className="pt-25 pb-80">
                    <div className="container">
                        <div className="bg-f8 rounded-3 px-3 px-sm-5 py-25 py-lg-30 mb-30">
                            <div className="text-center fw-medium fs-18 fs-lg-25 lh-13 text-primary">Recibimos la solicitud, la estaremos analizando y a la brevedad nos estaremos contactando con vos.</div>
                        </div>
                        <div className="py-3">
                            <div className="fs-17 fs-lg-18">
                                <b>Horarios de atención:</b><br />
                                - Ventas: lunes a viernes <br className="d-sm-none" />de  {DATA_CONTACTO[config.pais].horario_ventas}.<br />
                                - Atención al cliente: lunes a viernes <br className="d-sm-none" />de  {DATA_CONTACTO[config.pais].hoario_atencion}.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-f4 py-30 py-lg-50 position-relative">
                    <img className="d-none d-lg-block pos07 bottom-0" src={shape05} alt='' />
                    <img className="d-none d-lg-block pos06" src={shape06} alt='' />
                    <div className="container px-lg-5">
                        <div className="row justify-content-evenly">
                            <div className="col-lg-auto text-center text-lg-start">
                                <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black mb-lg-1">¿No resolvimos<br className="d-sm-none" /> tu consulta?</h2>
                                <p className="fw-bold fs-25 fs-lg-25 text-primary mb-18 mb-lg-0">¡Estamos para vos!</p>
                            </div>
                            <div className="col-lg-auto text-center text-lg-left">
                                <Link
                                    to="/contacto"
                                    className="transition-base d-inline-block w-250p py-12 rounded-3 fs-22 fs-lg-24 fw-bold lh-1 text-center bg-primary bg-lg-gray-dark hover-bg-primary text-white"
                                >
                                    CONTACTO
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}
